import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import UserDashboard from "./pages/UserDashboard";
import Calculator from "./pages/Calculator";
import Documents from "./pages/Documents";
import Support from "./pages/Support";
import ClientDetails from "./pages/ClientDetails";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMetrics from "./pages/AdminMetrics";
import Notifications from "./pages/Notifications";
import AdminNotifications from "./pages/AdminNotifications";
import AdminDocuments from "./pages/AdminDocuments";
import AdminChat from "./pages/AdminChat";
import Chat from "./pages/Chat";
import ClientOverview from "./pages/ClientOverview";
import { AllClientsView } from "@/components/admin/AllClientsView";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Client routes */}
          <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/overview" element={<ProtectedRoute><ClientOverview /></ProtectedRoute>} />
          <Route path="/calculator" element={<ProtectedRoute><Calculator /></ProtectedRoute>} />
          <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />

          {/* Admin routes */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/notifications" element={<ProtectedRoute adminOnly><AdminNotifications /></ProtectedRoute>} />
          <Route path="/admin/documents" element={<ProtectedRoute adminOnly><AdminDocuments /></ProtectedRoute>} />
          <Route path="/admin/chat" element={<ProtectedRoute adminOnly><AdminChat /></ProtectedRoute>} />
          <Route path="/admin/all-clients" element={<ProtectedRoute adminOnly><AllClientsView /></ProtectedRoute>} />
          <Route path="/admin/clients/:id" element={<ProtectedRoute adminOnly><ClientDetails /></ProtectedRoute>} />
          <Route path="/admin/metrics" element={<ProtectedRoute adminOnly><AdminMetrics /></ProtectedRoute>} />
        </Routes>
      </Router>
      <Toaster />
    </AuthProvider>
  );
}

export default App;